import { render } from "./PhoneInTalkOutline.vue?vue&type=template&id=62359881"
import script from "./PhoneInTalkOutline.vue?vue&type=script&lang=js"
export * from "./PhoneInTalkOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__